export type AuthMode = "private" | "public";

export const API_BASE_URL = "/api/v1-alpha";
